<template>
  <div>
    <base-field label="Postcode" mandatory>
      <base-input v-model="value.postcode" :personal="personal" placeholder="postcode" required />
      <template v-slot:addonRight>
        <base-button :disabled="!canLookup" :loading="searching" primary @click="lookup">
          Lookup
        </base-button>
      </template>
    </base-field>
    <base-modal :target="autoTarget" :title="`Results for: ${postcode}`">
      <div class="list-group">
        <template v-for="(result, key) in results">
          <button
            type="button"
            class="list-group-item list-group-item-action"
            :key="key"
            @click="select(key)">
            <formatted-address :address="result" />
          </button>
        </template>
      </div>
    </base-modal>

    <div v-if="completed()" class="p-2 mb-3 bg-light border">
      <small>
        <formatted-address :address="value" />
      </small>
    </div>

    <base-button primary @click="$modal.show(`#${manualTarget}`)">
      Enter Address Manually
    </base-button>

    <form @submit.prevent="close">
      <base-modal :target="manualTarget" title="Enter Address">
        <base-field label="Address Line 1">
          <base-input v-model="value.addressLine1" :personal="personal" placeholder="first line of address" required />
        </base-field>
        <base-field label="Address Line 2">
          <base-input v-model="value.addressLine2" :personal="personal" placeholder="second line of address" />
        </base-field>
        <base-field label="Town">
          <base-input v-model="value.town" :personal="personal" placeholder="town" required />
        </base-field>
        <base-field label="County">
          <base-input v-model="value.county" :personal="personal" placeholder="county" required />
        </base-field>
        <base-field label="Post Code">
          <base-input v-model="value.postcode" :personal="personal" placeholder="postcode" required />
        </base-field>
        <base-field label="Country">
          <base-select
            v-model="value.country"
            :personal="personal"
            placeholder="country of birth"
            required
            store="core.geoLookup.countries"
            store-action="core/geo-lookup/countries"
            store-value="name" />
        </base-field>
        <template v-slot:footer>
          <base-button secondary submit>Continue</base-button>
        </template>
      </base-modal>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import FormattedAddress from './FormattedAddress.vue'

export default {
  name: 'AddressFinder',

  components: {
    FormattedAddress
  },

  props: {
    personal: { default: false, type: Boolean },
    value: { default: () => {}, type: Object }
  },

  data: () => ({
    autoTarget: null,
    manualTarget: null,
    searching: false
  }),

  async created () {
    const id = this.$id.gen()

    this.autoTarget = `address-auto-${id}`
    this.manualTarget = `address-manual-${id}`

    await this.$store.dispatch('core/geo-lookup/countries')

    this.value.country = this.uk.name
  },

  computed: {
    canLookup () {
      return this.$_.trim(this.postcode) !== ''
    },

    postcode () {
      return this.value.postcode.toUpperCase()
    },

    ...mapGetters({
      uk: 'core/geo-lookup/uk'
    }),

    ...mapState({
      countries: store => store.core.geoLookup.countries,
      results: store => store.core.geoLookup.addresses
    })
  },

  methods: {
    completed () {
      const {
        nameNumber, addressLine1, town, postcode
      } = this.value

      if (nameNumber !== '' && addressLine1 !== '' && town !== '' && postcode !== '') {
        return true
      }

      return false
    },

    lookup () {
      this.searching = true

      this.findAddresses({ postcode: this.value.postcode })
        .then(() => {
          this.$modal.show(`#${this.autoTarget}`)
        })
        .catch(err => this.$flash.failure(err))
        .finally(() => {
          this.searching = false
        })
    },

    close () {
      this.$modal.close(`#${this.autoTarget}`)
      this.$modal.close(`#${this.manualTarget}`)
    },

    select (index) {
      const address = this.results[index]
      address.postcode = this.value.postcode
      address.country = this.uk.name

      this.$emit('input', address)
      this.close()
    },

    ...mapActions({
      findAddresses: 'core/geo-lookup/addresses'
    })
  }
}
</script>
